
// Code To Success React pages
import Courses from "pages/LandingPages/Courses";

export default function CoursesPage() {
  return <Courses />;
}
